/*
This action file conatin the action related to company edit , support 
*/

import * as api from '../api';

export const EDIT_COMPANY_REQUEST='EDIT_COMPANY_REQUEST';
export const EDIT_COMPANY_FAILURE='EDIT_COMPANY_FAILURE';
export const EDIT_COMPANY_SUCCESS='EDIT_COMPANY_SUCCESS';
export const NOTIFICATION_ADD = 'NOTIFICATION_ADD';
export function submitComponyEdit(formdata,compid,name,address, stripeEmail, customer_email){
	return function(dispatch, getState){
	    dispatch({
	      type: EDIT_COMPANY_REQUEST
	    });
	    api.uploadCompanyLogo(formdata,compid).then(
	    	(response)=>{
	    		dispatch({
		          type: 'EDIT_COMPANY_PIC_REQUEST_SUCCESS',
		          companyupdate: response
		        });
			    api.submitComponyEdit(compid,name,address, stripeEmail, customer_email).then(
			    	(response) => {
			    		
				        dispatch({
				          type: EDIT_COMPANY_SUCCESS,
				          address: response
				        });
				        dispatch({
				          type: NOTIFICATION_ADD,
				          text: 'Company data edited successfully',
				          msgtype: 'success'
				        });
				      },
				      (error) => {
				        dispatch({
				          type: EDIT_COMPANY_FAILURE,
				          error: error,
				          message: error.message || 'Could not submit company data.'
				        });
				        dispatch({
				          type: NOTIFICATION_ADD,
				          text: error.message || 'Could not submit company data.',
				          msgtype: 'danger'
				        });
				      }
			    );
			},
		    (error) => {
	    		dispatch({
		          type: EDIT_COMPANY_FAILURE,
		          error: error,
		          message: error.message || 'Could not complete edit company request, company pic not uploaded.'
		        });
		        dispatch({
		          type: NOTIFICATION_ADD,
		          text: error.message || 'Could not complete edit company request, company pic not uploaded.',
		          msgtype: 'danger'
		        });
	    	}
		);
	};
}
export function unsetCompanyeditFlag(){
	return function(dispatch, getState){
		dispatch({
	      type: 'Unset_Company_Edit_Flag',
	    });
	 };
}
export const SEND_SUPPORT_MESSAGE_REQUEST='SEND_SUPPORT_MESSAGE_REQUEST';
export const SEND_SUPPORT_MESSAGE_REQUEST_FAILURE='SEND_SUPPORT_MESSAGE_REQUEST_FAILURE';
export const SEND_SUPPORT_MESSAGE_REQUEST_SUCCESS='SEND_SUPPORT_MESSAGE_REQUEST_SUCCESS';

export function supportContact(name,email,message,companyname,companyid,useremail){
	return function(dispatch, getState){
	    dispatch({
	      type: SEND_SUPPORT_MESSAGE_REQUEST
	    });
	    api.supportContact(name,email,message,companyname,companyid,useremail).then(
	    	(response) => {
		        dispatch({
		          type: SEND_SUPPORT_MESSAGE_REQUEST_SUCCESS,
		          response: response
		        });
		      },
		      (error) => {
		        dispatch({
		          type: SEND_SUPPORT_MESSAGE_REQUEST_FAILURE,
		          error: error,
		          message: error.message || 'Could not send Messsage to support.'
		        });
		      }
	    );
	};
}


export const SEND_CHANGE_MESSAGE_SENT_STATUS_REQUEST='SEND_CHANGE_MESSAGE_SENT_STATUS_REQUEST';

export function changeMessegeSentStatus(){
	return function(dispatch, getState){
	    dispatch({
	      type: SEND_CHANGE_MESSAGE_SENT_STATUS_REQUEST
	    });
	};
}

export const RESET_SUPPORT_POPUP = 'RESET_SUPPORT_POPUP';
export function resetSupportPopup(){
	return function(dispatch, getState){
	    dispatch({
	      type: RESET_SUPPORT_POPUP
	    });
	};
}

export const OPEN_SUPPORT_POPUP = 'OPEN_SUPPORT_POPUP';
export function openSupportPopup(){
	return function(dispatch, getState){
	    dispatch({
	      type: OPEN_SUPPORT_POPUP
	    });
	};
}
export const SEND_CANCEL_DOKKIT_REQUEST= 'SEND_CANCEL_DOKKIT_REQUEST'
export const SEND_CANCEL_DOKKIT_REQUEST_SUCCESS= 'SEND_CANCEL_DOKKIT_REQUEST_SUCCESS'
export const SEND_CANCEL_DOKKIT_REQUEST_FAILURE= 'SEND_CANCEL_DOKKIT_REQUEST_FAILURE'

export function cancelDokkit(userId, calltype){
	return function(dispatch, getState){
	    dispatch({
	      type: SEND_CANCEL_DOKKIT_REQUEST
	    });
	    return api.cancelDokkit(userId, calltype).then(
	    	(response) => {
	    		if(calltype === "admin_company_listing"){
	    			dispatch({
			          type: 'NOTIFICATION_ADD',
			          text: 'Dokkit cancelled!',
			          msgtype: 'success',
			        });
	    		}else{
	    			dispatch({
			          type: SEND_CANCEL_DOKKIT_REQUEST_SUCCESS,
			          response: response
			        });
	    		}
		        
		      },
		      (error) => {
		        dispatch({
		          type: SEND_CANCEL_DOKKIT_REQUEST_FAILURE,
		          error: error,
		          message: error.message || 'Could not cancel dookit request.'
		        });
		      }
	    );
	};
}

export function removeDokkitList(companyId){
	return function(dispatch){
    	dispatch({
          	type: 'CANCEL_DOKKIT_SUCCESS',
          	payload: {
          		companyId
          	}
        })
	};
}

export const SEND_CANCEL_DOKKIT_MESSAGE_REQUEST= 'SEND_CANCEL_DOKKIT_MESSAGE_REQUEST'
export const SEND_CANCEL_DOKKIT_REQUEST_MESSAGE_SUCCESS= 'SEND_CANCEL_DOKKIT_REQUEST_MESSAGE_SUCCESS'
export const SEND_CANCEL_DOKKIT_REQUEST_MESSAGE_FAILURE= 'SEND_CANCEL_DOKKIT_REQUEST_MESSAGE_FAILURE'

export function sendMailCancelDokkit(message, userId){
	return function(dispatch, getState){
	    dispatch({
	      type: SEND_CANCEL_DOKKIT_MESSAGE_REQUEST
	    });
	    api.sendMailCancelDokkit(message, userId).then(
	    	(response) => {
		        dispatch({
		          type: SEND_CANCEL_DOKKIT_REQUEST_MESSAGE_SUCCESS,
		          response: response
		        });
		      },
		      (error) => {
		        dispatch({
		          type: SEND_CANCEL_DOKKIT_REQUEST_MESSAGE_FAILURE,
		          error: error,
		          message: error.message || 'Could not send mail for unsubscribe dokkit.'
		        });
		      }
	    );
	};
}

/**
 * Removing manuals from admin panel for particular company.
 */
export const SEND_REMOVE_MANUAL_REQUEST= 'SEND_REMOVE_MANUAL_REQUEST'
export const SEND_REMOVE_MANUAL_REQUEST_SUCCESS= 'SEND_REMOVE_MANUAL_REQUEST_SUCCESS'
export const SEND_REMOVE_MANUAL_REQUEST_FAILURE= 'SEND_REMOVE_MANUAL_REQUEST_FAILURE'

export function removeCompanyTemplate(companyid, groupName, tmpSetId){
	return function(dispatch, getState){
	    dispatch({
	      type: SEND_REMOVE_MANUAL_REQUEST
	    });
	    api.removeCompanyTemplate(companyid, groupName, tmpSetId).then(
	    	(response) => {
		        dispatch({
		          type: SEND_REMOVE_MANUAL_REQUEST_SUCCESS,
		          response: response,
		          tmpSetId,
		          groupName
		        });
		        dispatch({
		          type: NOTIFICATION_ADD,
		          text: 'Manual Removed successfully.',
		          msgtype: 'success'
		        });
		      },
		      (error) => {
		        dispatch({
		          type: SEND_REMOVE_MANUAL_REQUEST_FAILURE,
		          error: error,
		          message: error.message || 'Could not remove manual.'
		        });
		        dispatch({
		          type: NOTIFICATION_ADD,
		          text: error.message || 'Could not remove manual.',
		          msgtype: 'danger'
		        });
		      }
	    );
	};
}

export const RESET_REMOVE_MANUAL_FLAG = 'RESET_REMOVE_MANUAL_FLAG';
export function resetManualRemovedFlag(){
	return function(dispatch, getState){
	    dispatch({
	      type: RESET_REMOVE_MANUAL_FLAG
	    });
	};
}


/*
Created by : Rahul Kumar
Created on : 07-11-2019
Purppose: Function to fetch company template set
*/


export const GET_TEMPLATE_SET_REQUEST= 'GET_TEMPLATE_SET_REQUEST'
export const GET_TEMPLATE_SET_SUCCESS= 'GET_TEMPLATE_SET_SUCCESS'
export const GET_TEMPLATE_SET_FAILURE= 'GET_TEMPLATE_SET_FAILURE'

export function getTemplateSet(companyId, calltype){
	return function(dispatch, getState){
	    dispatch({
	      type: GET_TEMPLATE_SET_REQUEST
	    });
	    api.getTemplateSet(companyId, calltype).then(
	    	(response) => {
		        dispatch({
		          type: GET_TEMPLATE_SET_SUCCESS,
		          response: response
		        });
		      },
		      (error) => {
		        dispatch({
		          type: GET_TEMPLATE_SET_FAILURE,
		          error: error,
		          message: error.message || 'Could not send mail for unsubscribe dokkit.'
		        });
		      }
	    );
	};
}



/*
Created by : Rahul Kumar
Created on : 08-11-2019
Purppose: Function to save new template set
*/


export const SAVE_TEMPLATE_SET_REQUEST= 'SAVE_TEMPLATE_SET_REQUEST'
export const SAVE_TEMPLATE_SET_SUCCESS= 'SAVE_TEMPLATE_SET_SUCCESS'
export const SAVE_TEMPLATE_SET_FAILURE= 'SAVE_TEMPLATE_SET_FAILURE'

export function saveTemplateSet(companyId, formData){
	return function(dispatch, getState){
	    dispatch({
	      type: SAVE_TEMPLATE_SET_REQUEST
	    });
	    return api.saveTemplateSet(companyId, formData).then(
	    	(response) => {
		        dispatch({
		          type: SAVE_TEMPLATE_SET_SUCCESS,
		          response: response
		        });
		      },
		      (error) => {
		      	error.then((err) => {
		      		dispatch({
			          type: SAVE_TEMPLATE_SET_FAILURE,
			          payload: err,
			        });

		      	})
		      	return error  
		        
		      }
	    );
	};
}


/*
Created by : Rahul Kumar
Created on : 11-11-2019
Purppose: Function to delete new template set
*/


export const DELETE_TEMPLATE_SET_REQUEST= 'DELETE_TEMPLATE_SET_REQUEST'
export const DELETE_TEMPLATE_SET_SUCCESS= 'DELETE_TEMPLATE_SET_SUCCESS'
export const DELETE_TEMPLATE_SET_FAILURE= 'DELETE_TEMPLATE_SET_FAILURE'

export function deleteTemplateSet(tmpSetId){

	return function(dispatch, getState){

	    dispatch({
	      type: DELETE_TEMPLATE_SET_REQUEST
	    });
	    return api.deleteTemplateSet(tmpSetId).then(
	    	(response) => {
		        dispatch({
		          type: DELETE_TEMPLATE_SET_SUCCESS,
		          tmpSetId
		        });
		      },
		      (error) => {
		        dispatch({
		          type: DELETE_TEMPLATE_SET_FAILURE,
		          error: error,
		          message: error.message || 'Could not send mail for unsubscribe dokkit.'
		        });
		      }
	    );
	};
}

export function _forceAuthoriseDone(){
	return function(dispatch, getState){
		dispatch({
          type: 'NOTIFICATION_ADD',
          text: 'Reauthorise completed successfully',
          msgtype: 'success'
        });
	 };
}

/*
Created by : Siraj
Created on : 09-May-2022
Purppose: Function to search company
*/


export const SEARCH_COMPANY_SET_REQUEST= 'SEARCH_COMPANY_SET_REQUEST'
export const SEARCH_COMPANY_SUCCESS= 'SEARCH_COMPANY_SUCCESS'
export const SEARCH_COMPANY_FAILURE= 'SEARCH_COMPANY_FAILURE'

export function searchCompany(search,activePage){

	return function(dispatch, getState){

	    dispatch({
	      type: SEARCH_COMPANY_SET_REQUEST
	    });
	    return api.searchCompany(search,activePage).then(
	    	(response) => {
		        dispatch({
		          type: SEARCH_COMPANY_SUCCESS,
		          company: response.company,
				  count: response.count
		        });
		      },
		      (error) => {
		        dispatch({
		          type: SEARCH_COMPANY_FAILURE,
		          error: error,
		          message: error.message || 'Could not search company'
		        });
		      }
	    );
	};
}


// WEBPACK FOOTER //
// ./src/Actions/company.js